import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';


export interface ProductMeasurementTypeUpsertState extends ApiState {
  productMeasurementTypeId?: string
}

export default requestReducer<ProductMeasurementTypeUpsertState>('PRODUCTMEASUREMENTTYPE_UPSERT')
